import Fuse from 'fuse.js';
import { useMemo, useState } from 'react';

export type useSearchOptions<T> = {
  searchKeys: Fuse.IFuseOptions<T>['keys'];
  dataSet: T[];
  options?: Fuse.IFuseOptions<T> & {
    maxLength?: number;
  };
};

const baseOptions: Fuse.IFuseOptions<unknown> = {};

const getSearchToken = (searchValue: string) => {
  // We are using "include-match" search-token
  // https://fusejs.io/examples.html#extended-search
  return `'${searchValue}`;
};

export function useSearch<T>({
  searchKeys,
  dataSet,
  options = {},
}: useSearchOptions<T>) {
  const [searchValue, setSearchValue] = useState<string>('');

  const results = useMemo(() => {
    const { maxLength } = options;
    if (maxLength && searchValue.length > maxLength) {
      return [];
    }

    const fuse = new Fuse([...dataSet], {
      keys: searchKeys,
      ...baseOptions,
      ...options,
    });

    return searchValue
      ? fuse.search(getSearchToken(searchValue)).map(({ item }) => item)
      : dataSet;
  }, [dataSet, searchKeys, options, searchValue]);

  return {
    searchValue,
    setSearchValue,
    results,
  };
}
